<template>
  <div class="container">
    <div
      style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px"
    >
      <a-form layout="inline">
        <a-form-item>
          <div class="form-item-content">
            <div class="label">搜索内容：</div>
            <a-input
              placeholder="用户OpenId"
              v-model:value="listRequest.content"
            />
          </div>
        </a-form-item>
        <a-form-item>
          <div class="form-item-content">
            <div class="label">支付状态：</div>
            <a-select style="width: 200px" v-model:value="listRequest.status">
              <a-select-option :value="1">未支付</a-select-option>
              <a-select-option :value="2">已支付</a-select-option>
              <a-select-option :value="3">支付失败</a-select-option>
            </a-select>
          </div>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleList">搜索</a-button>
          <a-button style="margin-left: 10px" @click="resetSearch"
            >重置
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :data-source="rechargeOrderList"
      :pagination="{
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      }"
      bordered
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'update_at'">
          <span
            >{{ dayjs(record.update_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'status'">
          <a-tag v-if="record.status === 1" color="yellow">未支付</a-tag>
          <a-tag v-if="record.status === 2" color="green">已支付</a-tag>
          <a-tag v-if="record.status === 3" color="red">支付失败</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'is_delete'">
          <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
          <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'create_at'">
          <span
            >{{ dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'operator'">
          <a-button
            @click="submitDelete(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }"
            >删除
          </a-button>
          <a-button
            @click="submitDrop(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff4d4f',
              color: 'white',
            }"
            >彻底删除
          </a-button>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { RechargeOrderListRequest } from "@/api/models/recharge_order/RechargeOrderListRequest";
import { RechargeOrder } from "@/api/models/recharge_order/RechargeOrder";
import { RechargeOrderService } from "@/api/services/RechargeOrderService";

const total = ref<number>(0);

const listRequest = reactive<RechargeOrderListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const rechargeOrderList = ref<RechargeOrder[]>([]);

const handleList = async () => {
  const res = await RechargeOrderService.ListAll(listRequest);
  if (res.code === 0) {
    rechargeOrderList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const resetSearch = () => {
  listRequest.current = 1;
  listRequest.size = 20;
  listRequest.content = "";
  listRequest.status = undefined;
  handleList();
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const submitDelete = async (record: RechargeOrder) => {
  const res = await RechargeOrderService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: RechargeOrder) => {
  const res = await RechargeOrderService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "用户OpenId",
    dataIndex: "user_open_id",
    align: "center",
  },
  {
    title: "充值金额",
    dataIndex: "recharge_amount",
    align: "center",
  },
  {
    title: "赠送金额",
    dataIndex: "bonus_amount",
    align: "center",
  },
  {
    title: "支付状态",
    dataIndex: "status",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "更新时间",
    dataIndex: "update_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
}

.form-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  white-space: nowrap;
}
</style>
